import {createMachine, actions, send, assign} from "xstate";
import validateUrlAsync from "resources/js/helpers/validateUrlAsync";

const createCreateEntryFormMachine = () => {
    return createMachine({
        id: 'create-entry-form-machine',
        initial: 'editing',
        context: {
            validationErrorMessage: null
        },
        states: {
            editing: {
                on: {
                    SUBMIT: 'validating'
                },
                initial: 'idle',
                states: {
                    idle: {},
                    invalid: {}
                },
            },
            validating: {
                invoke: {
                    id: 'validating',
                    src: (_, {url}) => validateUrlAsync(url),
                    onDone: {
                        target: 'submitting',
                        actions: assign({
                            validationErrorMessage: null
                        })
                    },
                    onError: {
                        target: 'editing.invalid',
                        actions: assign({
                            validationErrorMessage: (ctx, event) => event.data.message
                        })
                    }
                }
            },
            submitting: {
                invoke: {
                    id: 'submit',
                    src: 'execCreateEntryRequest',
                    onDone: {
                        target: 'editing',
                        actions: send('SUCCESS'),
                    },
                    onError: {
                        target: 'editing',
                        actions: send('VALIDATION_ERROR')
                    }
                }
            }
        }
    })
};

export {createCreateEntryFormMachine};
